// ./src/index.js
import React from "react";
import ReactDOM from "react-dom";

// import ApplyAppWrapper from "@jobBoard/src/views/ApplyApp/wrapper.js";
// import store from "@jobBoard/src/lib/store";

import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@emotion/react";
import theme from "@ats/styles/theme";
import lightTheme from "@shared/styles/lightTheme";

import ApplyApp from "@jobBoard/src/views/ApplyApp";

function App(props) {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        theme={{
          ...theme,
          poly: lightTheme
        }}
      >
        <ApplyApp {...props} />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("apply")) {
    const render = (Component = App) => {
      ReactDOM.render(<Component />, document.getElementById("apply"));
    };

    render(undefined);
  }
});
